import React from 'react';
import './Sidebar.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SidebarPropTypes, ProfileInfoPropTypes } from '../utils/propTypes';

const ProfileInfo = ({ user }) => (
    <div className="profile-info">
        <img className='rounded-circle' src={user?.image} alt='Not Found' width={'120px'} />
        <h5>{user?.first_name} {user?.last_name}</h5>
        <p>{user?.role || 'N/A'}</p>
    </div>
);

const Sidebar = ({ isOpen, toggleSidebar, isMobileView }) => {
    const authCtx = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleLogout = () => {
        authCtx.onLogOut();
    };

    const handleChangePassword = () => {
        toggleSidebar();
        navigate('/change-password');
    };

    const menuItems = [
        {
            path: '/home',
            icon: <i className="bi bi-house-door menu-item-icon"></i>,
            label: 'Home'
        },
        {
            path: '/my-profile',
            icon: <i className="bi bi-person menu-item-icon"></i>,
            label: 'My Profile'
        },
        {
            path: '/my-session',
            icon: <i className="bi bi-person menu-item-icon"></i>,
            label: 'My Session'
        },
        {
            path: '/about-us',
            icon: <i className="bi bi-info-circle menu-item-icon"></i>,
            label: 'About TMS'
        },
        {
            path: '/care',
            icon: <span className='material-icons'>support_agent</span>,
            label: 'The Care Space'
        }
    ];

    const renderMenuItems = (withLogout = false) => (
        <ul className='menu-list custom-font' style={{ listStyleType: 'none', padding: '0px' }}>
            {menuItems.map(item => (
                <li key={item.path} className={currentPath === item.path ? 'active-menu-item menu-item' : 'menu-item'}>
                    <NavLink to={item.path}>
                        {item.icon}
                        <span className='menu-item-label'>{item.label}</span>
                    </NavLink>
                </li>
            ))}
            {withLogout && (
                <>
                    <li className='menu-item'>
                        <button onClick={handleChangePassword} className='d-flex align-items-center p-0' style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#515151' }}>
                            <i className="bi bi-key menu-item-icon"></i>
                            <span className='menu-item-label'>Change Password</span>
                        </button>
                    </li>
                    <li className='menu-item'>
                        <button onClick={handleLogout} className='d-flex align-items-center p-0' style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#515151' }}>
                            <span className='material-icons'>power_settings_new</span>
                            <span className='menu-item-label'>Logout</span>
                        </button>
                    </li>
                </>
            )}
        </ul>
    );

    if (!isMobileView) {
        return (
            <aside className={`sidebar desktop-view ${isOpen ? 'open' : 'closed'}`}>
                <ProfileInfo user={authCtx.user} />
                <nav className='nav-list-container'>
                    {renderMenuItems()}
                </nav>
            </aside>
        );
    }

    // Mobile view
    return (
        <div className="container-fluid-mobile-view navbar navbar-dark bg-dark">
            <div className={`custom-offcanvas offcanvas offcanvas-end ${isOpen ? 'show' : 'hide'}`} tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div className="offcanvas-header">
                    <button type="button" onClick={() => { toggleSidebar() }} className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <ProfileInfo user={authCtx.user} />
                    <nav className='nav-list-container'>
                        {renderMenuItems(true)}
                    </nav>
                </div>
            </div>
        </div>
    );
};

ProfileInfo.propTypes = ProfileInfoPropTypes;
Sidebar.propTypes = SidebarPropTypes;

export default Sidebar;